import { Entypo } from "@expo/vector-icons";
import React, { useState } from "react";
import { Pressable, View } from "react-native";
import ActionPopover from "./ActionPopover";

interface TicketActionProps {
  onReleaseBtnPress: () => void;
  shouldShowRelease: boolean;
  isGroupReservation: boolean;
  allowGroupCodeReleases: boolean;
}

const DeleteIcon = (
  <Entypo name="circle-with-cross" size={24} color="rgb(247, 118, 67)" />
);

const TicketAction: React.FC<TicketActionProps> = ({
  onReleaseBtnPress,
  shouldShowRelease,
  isGroupReservation,
  allowGroupCodeReleases,
}) => {
  const [popOver, setPopover] = useState(false);

  const handlePress = () => {
    if (isGroupReservation && !allowGroupCodeReleases) {
      setPopover(true);
      return;
    }
    onReleaseBtnPress();
  };

  if (shouldShowRelease) {
    return (
      <View>
        <ActionPopover
          visible={popOver}
          setVisible={setPopover}
          anchor={() => (
            <Pressable onPress={handlePress} testID="reservation-release-icon">
              {DeleteIcon}
            </Pressable>
          )}
        ></ActionPopover>
      </View>
    );
  }

  return <View style={{ width: 24 }}></View>; // acts as a placeholder for the delete icon
};

export default TicketAction;
